import { createMiddleware } from 'redux-beacon';
import logger from '@redux-beacon/logger';
import { forEach, defaultTo, assoc, merge } from 'ramda';
import URL from 'url';

function createAnalyticsMiddleware(target, events) {
  // No tracking on server-side
  if (!process.browser) {
    return function () {
      return function (next) {
        return function (action) {
          return next(action);
        };
      };
    };
  }

  // No tracking in development environment
  if (process.env.NODE_ENV !== 'production') {
    return createMiddleware(events, function () {}, { logger: logger });
  }

  return createMiddleware(events, target);
}

/** @module analytics/netrefer */

function createNetreferExtension(options) {
  var endpointUrlObject = URL.parse(options.endpoint);

  return function (events) {
    if (process.browser) {
      forEach(function (event) {
        if (event.btag) {
          var customFields = defaultTo({}, event.customFields);
          var urlObject = assoc('query', merge(customFields, {
            ActionName: event.actionName,
            TrackingTag: event.btag,
            b: event.brand || 'all',
            clientID: options.clientId,
            s: event.source || 'all',
            to: event.method || 'store'
          }), endpointUrlObject);

          var pixel = new Image();
          pixel.src = URL.format(urlObject);
        }
      }, events);
    }
  };
}

/**
 * Set up NetRefer Pixel Tracking middleware
 * @memberof analytics/netrefer
 * @param {Object} events
 * @param {Object} options
 * @param {string} options.clientId NetRefer client ID (cid)
 * @param {string} options.endpoint Host and pathname to fetch pixel from
 * @returns {Function} Redux middleware
 */
function middleware(events, options) {
  return createAnalyticsMiddleware(createNetreferExtension(options), events);
}

export { middleware };
